import { useSession } from "next-auth/client";
import { repository } from "repositories";
import { GetCalledFortuneTellerRes, SWRResponse } from "shared/types";
import useSWR from "swr";

export const useCalledFortuneTeller = (
  fortuneTellerId: number | string
): SWRResponse<GetCalledFortuneTellerRes> => {
  const [session] = useSession();

  const path =
    repository.calledFortuneTeller.getCalledFortuneTellerPath(fortuneTellerId);
  const fetcher = () =>
    repository.calledFortuneTeller.getCalledFortuneTeller(fortuneTellerId);

  const { data, error } = useSWR(
    session && fortuneTellerId ? path : null,
    fetcher
  );

  return {
    fortuneTeller: data?.fortuneTeller,
    isLoading: !data && !error,
    isError: !!error,
  };
};
